<template>
    <div>
        <el-dialog
                title="Confirmation de suppression :"
                :visible.sync="modalConfirmedDeleteList"
                width="30%"
        >
            <span class="text-left">{{titreModalConfirmedDeleteList}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="SET_MODAL_CONFIRMED_DELETE_LIST(false)">Annuler</el-button>
                <el-button v-if="selected.length == 1" type="danger" @click="$emit('delete-selected')"> {{ $t("posts.list.delete") }}</el-button>
                <el-button v-else type="danger" @click="$emit('delete-all-selected')"> {{ $t("posts.list.delete") }}</el-button>
            </span>
        </el-dialog>
    </div>

</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import ElButton from '../../../../components/Button'

export default {
  name: 'DialogDeleteMultiplePost',
  components: {
    ElButton
  },
  props: ['modalConfirmedDeleteList', 'selected', 'titreModalConfirmedDeleteList'],
  data () {
    return {
      referenceDuplication: null
    }
  },
  computed: {
    ...mapGetters(['hasMultiAccounts', 'isMainAccount', 'isSubAdmin', 'isSubUser', 'getOfferTypes', 'getPickerOptionsShortcuts']),
    userFilter () {
      return this.filter.user
    }
  },
  methods: {
    ...mapMutations('dialogsPostsListImmo', [
        'SET_MODAL_CONFIRMED_DELETE_LIST'
    ])
  },
  beforeMount () {

  }
}

</script>
